import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query terminalsList(
      $companyId: String
      $merchantId: String
      $terminalIds: String
      $rowFrom: Int
      $rowTo: Int
    ) {
      terminals(
        companyId: $companyId
        merchantId: $merchantId
        terminalIds: $terminalIds
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id: terminalId
        companyId
        merchantName
        mcc: mmc
        hasChip
        companyName
        merchantId
        lastSuccessTransactionDate
        lastTransactionDate
        terminalKeys
        currentRow
        totalRows
      }
    }
  `,
  variables: ({
    companyId,
    merchantId,
    terminalIds,
    page = 1,
    itemsPerPage = 10,
  }) => {
    const firstItem = (page - 1) * itemsPerPage || 1;
    const lastItem = firstItem + itemsPerPage;
    return {
      companyId,
      merchantId,
      terminalIds:
        terminalIds && terminalIds.join ? terminalIds.join(",") : terminalIds,
      rowFrom: firstItem,
      rowTo: lastItem,
    };
  },
  config: {
    pollInterval: 0,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    // fetchPolicy: "network-only",
  },
  propTypes: {
    companyId: PropTypes.string,
    merchantId: PropTypes.string,
    terminalIds: PropTypes.string,
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "terminals",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
  getTotal: (items) => (items && items.length ? items[0].totalRows : null),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/terminals.js